import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NzImageModule } from 'ng-zorro-antd/image'
import { IbransonPreviewPageComponent } from './ibranson-preview-page.component'
import { IbHeaderComponent } from './ib-header.component'
import { IbNavComponent } from './ib-nav.component'
import { IbHeroComponent } from './ib-hero.component'
import { IbProductHeaderComponent } from './ib-product-header.component'
import { IbOverviewComponent } from './ib-overview.component'
import { IbAvailabilityComponent } from './ib-availability.component'
import { IbPackagesComponent } from './ib-packages.component'
import { IbGalleryComponent } from './ib-gallery.component'
import { IbSeatMapComponent } from './ib-seat-map.component'
import { IbUnclassifiedComponent } from './ib-unclassified.component'
import { IbInfoComponent } from './ib-info.component'
import { IbFooterComponent } from './ib-footer.component'

@NgModule({
  declarations: [
    IbransonPreviewPageComponent,
    IbHeaderComponent,
    IbNavComponent,
    IbHeroComponent,
    IbProductHeaderComponent,
    IbOverviewComponent,
    IbAvailabilityComponent,
    IbPackagesComponent,
    IbGalleryComponent,
    IbSeatMapComponent,
    IbUnclassifiedComponent,
    IbInfoComponent,
    IbFooterComponent,
  ],
  imports: [CommonModule, NzImageModule],
  exports: [IbransonPreviewPageComponent],
})
export class IbransonPreviewModule {}
